import { render } from "./Notice.vue?vue&type=template&id=65cd9ffd"
import script from "./Notice.vue?vue&type=script&lang=js"
export * from "./Notice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/userSupport/Notice.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65cd9ffd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65cd9ffd', __exports__)) {
    api.reload('65cd9ffd', __exports__)
  }
  
  module.hot.accept("./Notice.vue?vue&type=template&id=65cd9ffd", () => {
    api.rerender('65cd9ffd', render)
  })

}


export default __exports__